import jQuery from 'jquery';

function Ctrl($scope, $timeout, $window, $uibModalInstance) {
  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };

  $timeout(function() {
    const element = jQuery('.search-modal input');

    if (element) {
      element.focus();
    }
  }, 300);
}

Ctrl.$inject = [
  '$scope',
  '$timeout',
  '$window',
  '$uibModalInstance'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/search/searchModalCtrl.js